import { Router } from '@angular/router';
import { routes } from '@nebular/auth';
import { NbMenuItem } from '@nebular/theme';
import { AppRoles } from '../model/applicationRoles';
import { Authorization } from '../model/authorization';
import { AuthRoles } from '../model/AuthRoles';
import { ConfKeys } from '../model/configurationKeys';
import { MenuItemRestriction } from '../model/MenuItem';
import { UserRoles } from '../model/userRoles';
import { AuthService } from '../service/auth.service';
import { ConfigurationService } from '../service/configuration.service';

export class MountMenu {
  /* Quando for criar uma nova rota:
      - Criar um atributo private static;
      - Em mount() inserir o atributo nas roles que podem acessa-lo;
      - Em _mount_by_authorization() inserir o atributo se depende de uma autorização;
      - Em select() Inserir o atributo no array;
  */

  /*
   Ao criar novo menu
    -Nome do titulo vai ser o nome da chave do json
    -Adicionar nome do titulo nos arquivos (pt.json, en.json, es.json) para a tradução
  */

  // private static _MENU_AUTH_VISITOR: NbMenuItem = {
  //   title: 'Visitantes',
  //   icon: 'people-outline',
  //   link: '/pages/authorizations-visitor',
  //   home: true,
  // };
  // private static _MENU_LOBBY: NbMenuItem = {
  //   title: 'Lobby de espera',
  //   icon: 'people-outline',
  //   link: '/pages/lobby',
  //   home: true,
  // };
  private static _MENU_DASHBOARD: NbMenuItem = {
    title: "DASHBOARD",
    icon: "bar-chart-outline",
    link: "/pages/dashboard",
    home: true,
  };
  private static _MENU_AUTHORIZATIONS: NbMenuItem = {
    title: "AUTHORIZATIONS",
    icon: "people-outline",
    link: "/pages/authorizations",
    home: true,
  };
  private static _MENU_INVITES: NbMenuItem = {
    title: "INVITATIONS",
    icon: "email-outline",
    link: "/pages/invites",
    home: true,
  };
  private static _MENU_RESIDENCE: NbMenuItem = {
    title: "RESIDENCES",
    icon: "home-outline",
    link: "/pages/residences",
    home: true,
  };
  private static _MENU_COMPANY: NbMenuItem = {
    title: "COMPANIES",
    icon: "briefcase-outline",
    link: "/pages/companies",
    home: true,
  };
  private static _MENU_DELIVERY_PACKAGE: NbMenuItem = {
    title: "DELIVERY_PACKAGE",
    icon: "gift-outline",
    link: "/pages/delivery-package",
    home: true,
  };
  private static _MENU_ACCESS_POINT: NbMenuItem = {
    title: "SETTINGS_ACCESS_POINT",
    icon: "swap-outline",
    link: "/pages/access-point",
    home: true,
  };

  private static _MENU_CHARGE_RULE: NbMenuItem = {
    title: "SETTINGS_CHARGE_RULE",
    icon: "credit-card-outline",
    link: "/pages/charge-rule",
    home: true,
  };

  private static _MENU_ACCESS_GROUPS: NbMenuItem = {
    title: "SETTINGS_ACCESS_GROUP",
    icon: "person-outline",
    link: "/pages/access-groups",
    home: true,
  };

  private static _MENU_ANTIPASSBACK: NbMenuItem = {
    title: "SETTINGS_ANTIPASSBACK",
    icon: "log-in-outline",
    link: "/pages/antipassback",
    home: true,
  };

  private static _MENU_ACCESS_REPORT: NbMenuItem = {
    title: "REPORTS_ACCESS_HISTORY_PEOPLE",
    icon: "person-outline",
    link: "/pages/report",
    home: true,
  };
  private static _MENU_REPORT_VEHICLE: NbMenuItem = {
    title: "REPORTS_ACCESS_HISTORY_VEHICLE",
    icon: "car-outline",
    link: "/pages/report-vehicle",
    home: true,
  };
    private static _MENU_REPORTS_BLOCKADE: NbMenuItem = {
    title: "REPORTS_BLOCKADE",
    icon: "lock-outline",
    link: "/pages/report-blockades",
    home: true,
  }
  private static _MENU_REPORT_USERS: NbMenuItem = {
    title: "REPORTS_PHOTO_SIMILARITY_USERS",
    icon: "people-outline",
    link: "/pages/report-similarity-users",
    home: true,
  };
  private static _MENU_REPORTS_REGISTERS_USERS: NbMenuItem = {
    title: "REPORTS_REGISTRATIONS_PEOPLE",
    icon: "person-outline",
    link: "/pages/report-register-users",
    home: true,
  };
  private static _MENU_REPORTS_REGISTERS_AUTHORIZATIONS: NbMenuItem = {
    title: "REPORTS_REGISTRATIONS_AUTHORIZATIONS",
    icon: "people-outline",
    link: "/pages/report-register-authorizations",
    home: true,
  };
  private static _MENU_REPORTS_REGISTERS_VEHICLES: NbMenuItem = {
    title: "REPORTS_REGISTRATIONS_VEHICLES",
    icon: "car-outline",
    link: "/pages/report-register-vehicles",
    home: true,
  };
  private static _MENU_REPORT_AUDIT: NbMenuItem = {
    title: "REPORTS_AUDIT_CHANGE_HISTORY",
    icon: "file-outline",
    link: "/pages/report-audit",
    home: true,
  };
  private static _MENU_REPORT_PARTNER_AUDIT: NbMenuItem = {
    title: "REPORTS_AUDIT_PARTBER_INTERFACE",
    icon: "file-outline",
    link: "/pages/report-partner-audit",
    home: true,
  };
  private static _MENU_REPORT_USER_DATA_REQUEST: NbMenuItem = {
    title: "REPOSTS_AUDIT_USER_DATA_REQUEST",
    icon: "file-outline",
    link: "/pages/report-user-data-request",
    home: true
  };
  private static _MENU_REPORT_ONBOARDING: NbMenuItem = {
    title: "REPORTS_ONBOARDING_HISTORY",
    icon: "file-outline",
    link: "/pages/report-onboarding",
    home: true,
  };
  private static _MENU_REPORT_PEOPLE_INSIDE_ENTERPRISE: NbMenuItem = {
    title: "REPORTS_PEOPLE_INSIDE_ENTERPRISE",
    icon: "log-in-outline",
    link: "/pages/report-people-inside-enterprise",
    home: true
  }
  private static _MENU_REPORT_CHARGE_RULE_PERSON: NbMenuItem = {
    title: "REPORT_CHARGE_RULE_PERSON",
    icon: "file-outline",
    link: "/pages/report-charge-rule-person",
    home: true,
  };
  private static _MENU_REPORT_CHARGE_RULE_ANALYTICAL_LISTING: NbMenuItem = {
    title: "REPORT_CHARGE_RULE_ANALYTICAL_LISTING",
    icon: "file-outline",
    link: "/pages/report-charge-rule-analytical-listing",
    home: true,
  };
  private static _MENU_REPORT_REQUEST_CONTROL: NbMenuItem = {
    title: "REPORTS_MY_REPORTS",
    icon: "download-outline",
    link: "/pages/report-request-control",
    home: true
  }
  private static _MENU_REPORT_PEOPLE_WITH_TEMPORARY_BADGES: NbMenuItem = {
    title: "REPORT_PEOPLE_WITH_TEMPORARY_BADGES",
    icon: "credit-card-outline",
    link: "/pages/report-temporary-rfid-card",
    home: true,
  };
  private static _MENU_REPORT_VEHICLE_SPEEED: NbMenuItem = {
    title: "REPORT_VEHICLE_SPEED",
    icon: "battery-outline",
    link: "/pages/report-vehicle-speed",
    home: true,
  };
  private static _MENU_REPORTS_PHOTO_SIMILARITY: NbMenuItem = {
    title: "REPORTS_PHOTO_SIMILARITY",
    icon: "image-outline",
    expanded: false,
    children: [MountMenu._MENU_REPORT_USERS],
  };
  private static _MENU_REPORTS_HISTORY: NbMenuItem = {
    title: "REPORTS_ACCESS_HISTORY",
    icon: "book-outline",
    expanded: false,
    children: [
      MountMenu._MENU_ACCESS_REPORT, 
      MountMenu._MENU_REPORT_VEHICLE,
      ],
  };
  private static _MENU_REPORTS_REGISTERS: NbMenuItem = {
    title: "REPORTS_REGISTRATIONS",
    icon: "book-open-outline",
    expanded: false,
    children: [
      MountMenu._MENU_REPORTS_REGISTERS_USERS,
      MountMenu._MENU_REPORTS_REGISTERS_AUTHORIZATIONS,
      MountMenu._MENU_REPORTS_REGISTERS_VEHICLES,
    ],
  };
  private static _MENU_REPORTS_AUDIT: NbMenuItem = {
    title: "REPORTS_AUDIT",
    icon: "file-outline",
    expanded: false,
    children: [MountMenu._MENU_REPORT_AUDIT, MountMenu._MENU_REPORT_PARTNER_AUDIT, MountMenu._MENU_REPORT_USER_DATA_REQUEST],
  };
  private static _MENU_REPORTS_CHARGE_RULES: NbMenuItem = {
    title: "REPORTS_CHARGE_RULES",
    icon: "file-outline",
    expanded: false,
    children: [MountMenu._MENU_REPORT_CHARGE_RULE_PERSON, MountMenu._MENU_REPORT_CHARGE_RULE_ANALYTICAL_LISTING]
  };
  private static _MENU_REPORTS: NbMenuItem = {
    title: "REPORTS",
    icon: "file-outline",
    expanded: false,
    children: [
      MountMenu._MENU_REPORTS_PHOTO_SIMILARITY,
      MountMenu._MENU_REPORTS_HISTORY,
      MountMenu._MENU_REPORT_PEOPLE_WITH_TEMPORARY_BADGES,
      MountMenu._MENU_REPORTS_BLOCKADE,
      MountMenu._MENU_REPORTS_CHARGE_RULES,
      MountMenu._MENU_REPORT_ONBOARDING,
      //MountMenu._MENU_REPORT_PEOPLE_INSIDE_ENTERPRISE,
      MountMenu._MENU_REPORTS_REGISTERS,
      MountMenu._MENU_REPORTS_AUDIT,
      MountMenu._MENU_REPORT_VEHICLE_SPEEED,
      MountMenu._MENU_REPORT_REQUEST_CONTROL
    ],
    //children: [MountMenu._MENU_REPORTS_PHOTO_SIMILARITY, MountMenu._MENU_REPORTS_HISTORY, MountMenu._MENU_REPORTS_REGISTERS, MountMenu._MENU_REPORTS_AUDIT]
  };
  private static _MENU_USR_MANAGEMENT: NbMenuItem = {
    title: "SETTINGS_OPERATORS",
    icon: "shield-outline",
    link: "/pages/management",
    home: true,
  };
  private static _MENU_DEVICES: NbMenuItem = {
    title: "DEVICES",
    icon: "camera-outline",
    link: "/pages/devices",
    home: true,
  };
  // private static _MENU_AUTH_RESIDENTS: NbMenuItem = {
  //   title: 'Residentes',
  //   icon: 'person-outline',
  //   link: '/pages/authorizations-resident',
  //   home: true,
  // };
  // private static _MENU_AUTH_EMPLOYEE: NbMenuItem = {
  //   title: 'Colaboradores',
  //   icon: 'person-outline',
  //   link: '/pages/authorizations-employee',
  //   home: true,
  // };
  // private static _MENU_AUTHORIZATIONS: NbMenuItem = {
  //   title: 'Autorizações',
  //   icon: 'people-outline',
  //   expanded: false,
  //   children: [MountMenu._MENU_AUTH_RESIDENTS, MountMenu._MENU_AUTH_EMPLOYEE]
  // };
  private static _MENU_LICENSE: NbMenuItem = {
    title: "SETTINGS_LICENCE",
    icon: "lock-outline",
    link: "/pages/license",
    home: true,
  };
  private static _MENU_IMPORTS: NbMenuItem = {
    title: "SETTINGS_IMPORTS",
    icon: "cloud-upload-outline",
    link: "/pages/imports",
    home: true,
  };
  private static _MENU_RECENT_ACCS_PERSON: NbMenuItem = {
    title: "RECENT_ACCESS_PEOPLE",
    icon: "person-outline",
    link: "/pages/recent-access",
    home: true,
  };
  private static _MENU_RECENT_ACCS_VEHICLE: NbMenuItem = {
    title: "RECENT_ACCESS_VEHICLE",
    icon: "car-outline",
    link: "/pages/recent-access-vehicles",
    home: true,
  };
  private static _MENU_RECENT_ACCS: NbMenuItem = {
    title: "RECENT_ACCESS",
    icon: "log-in-outline",
    expanded: false,
    children: [
      MountMenu._MENU_RECENT_ACCS_PERSON,
      MountMenu._MENU_RECENT_ACCS_VEHICLE,
    ],
  };

  private static _MENU_SCHEDULE: NbMenuItem = {
    title: "SETTINGS_TIME_CONTROL",
    icon: "clock-outline",
    link: "/pages/schedule",
    home: true,
  };

  private static _MENU_VARIABLES: NbMenuItem = {
    title: "SETTINGS_ENVIRONMENT_VARIABLES",
    icon: "settings-2-outline",
    link: "/pages/settings",
    home: true,
  };

  private static _MENU_SETTINGS: NbMenuItem = {
    title: "SETTINGS",
    icon: "settings-2-outline",
    expanded: false,

    children: [
      MountMenu._MENU_ACCESS_GROUPS,
      MountMenu._MENU_ACCESS_POINT,
      MountMenu._MENU_CHARGE_RULE,
      MountMenu._MENU_ANTIPASSBACK,
      MountMenu._MENU_LICENSE,
      MountMenu._MENU_IMPORTS,
      MountMenu._MENU_USR_MANAGEMENT,
      MountMenu._MENU_SCHEDULE,
      MountMenu._MENU_VARIABLES,
    ],
  };

  private static restrictions: MenuItemRestriction[] = [
    {
      route: "/pages/dashboard",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [],
    },
    {
      route: "/pages/authorizations",
      allowedRoles: [UserRoles.manager, UserRoles.operator, UserRoles.user],
      conditionForRoles: [],
    },
    {
      route: "/pages/invites",
      allowedRoles: [UserRoles.manager, UserRoles.operator, UserRoles.user],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.CentralInvitesMenuEnabled,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.CentralInvitesMenuEnabled,
        },
        {
          forRole: UserRoles.user,
          condition: ConfKeys.CentralInvitesMenuEnabled,
        },
      ],
    },
    // RECENT ACCESS MENU
    {
      route: "/pages/recent-access-vehicles",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        }
      ],
    },
    {
      route: "/pages/recent-access",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegistePeople,
        }
      ],
    },
    // UNITS
    {
      route: "/pages/residences",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.none,
          condition: ConfKeys.IsResidentialModeEnabled,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorResidencesEnabled,
        },
      ],
    },
    {
      route: "/pages/companies",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        { forRole: UserRoles.none, condition: ConfKeys.IsBussinesModeEnabled },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorCompaniesEnabled,
        },
      ],
    },
    // REPORT MENU
    {
      route: "/pages/report-similarity-users",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
      ],
    },
    {
      route: "/pages/delivery-package",
      allowedRoles: [UserRoles.manager, UserRoles.operator, UserRoles.user],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.Module_PackageRegistrationEnabled,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.Module_PackageRegistrationEnabled,
        },
        {
          forRole: UserRoles.user,
          condition: ConfKeys.Module_PackageRegistrationEnabled,
        },
      ],
    },
    {
      route: "/pages/report",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeUserDocsOnReports,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
      ],
    },
    {
      route: "/pages/report-vehicle",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeVehicles,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        }
      ],
    },
    {
      route: "/pages/report-vehicle-speed",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeVehicles,
        },
        { forRole: UserRoles.operator, condition: ConfKeys.OperatorSeeReports },
      ],
    },
    {
      route: "/pages/report-register-users",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeUserDocsOnReports,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
      ],
    },
    {
      route: "/pages/report-register-authorizations",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeUserDocsOnReports,
        },
        { forRole: UserRoles.operator, condition: ConfKeys.OperatorSeeReports },
      ],
    },
    {
      route: "/pages/report-register-vehicles",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeVehicles,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.IsPermitedRegisteVehicle,
        }
      ],
    },
    {
      route: "/pages/report-charge-rule-person",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeVehicles,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.EnableMenuChargeRule
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.EnableMenuChargeRule
        },
      ],
    },
    {
      route: "/pages/report-charge-rule-analytical-listing",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeVehicles,
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.OperatorSeeReports
        },
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.EnableMenuChargeRule
        },
        {
          forRole: UserRoles.operator,
          condition: ConfKeys.EnableMenuChargeRule
        },
      ],
    },
    {
      route: "/pages/report-blockades",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        { 
          forRole: UserRoles.operator, 
          condition: ConfKeys.OperatorSeeReports 
        },
        { 
          forRole: UserRoles.manager,
          condition: ConfKeys.EnableBlockade
        },
        { 
          forRole: UserRoles.operator,
          condition: ConfKeys.EnableBlockade
        },
      ],
    },
    {
      route: "/pages/devices",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/report-audit",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/report-partner-audit",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/report-user-data-request",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/report-onboarding",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
      ],
    },
    {
      route: "/pages/report-people-inside-enterprise",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.IsPermitedRegistePeople,
        },
      ],
    },
    {
      route: "/pages/report-temporary-rfid-card",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        { 
          forRole: UserRoles.operator, 
          condition: ConfKeys.OperatorSeeReports
        },
      ],
    },
    {
      route: "/pages/report-request-control",
      allowedRoles: [UserRoles.manager, UserRoles.operator],
      conditionForRoles: [
        { forRole: UserRoles.operator, condition: ConfKeys.OperatorSeeReports },
      ],
    },
    // SETTINGS
    {
      route: "/pages/access-groups",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/access-point",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/charge-rule",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [
        {
          forRole: UserRoles.manager,
          condition: ConfKeys.EnableMenuChargeRule
        },
      ],
    },
    {
      route: "/pages/antipassback",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/license",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/imports",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/management",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/schedule",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
    {
      route: "/pages/settings",
      allowedRoles: [UserRoles.manager],
      conditionForRoles: [],
    },
  ];

  private static menu: NbMenuItem[] = [];

  public static getMenu() {
    return this.menu;
  }

  public static removeMenuItem(menu: NbMenuItem[], itemLink: string) {
    for (let i = 0; i < menu.length; i++) {
      let menuItem = menu[i];

      if (menuItem.link == itemLink) {
        menu.splice(menu.indexOf(menuItem), 1);
        break;
      } else if (menuItem.children != undefined) {
        MountMenu.removeMenuItem(menuItem.children, itemLink);

        if (menuItem.children.length == 0) {
          menu.splice(menu.indexOf(menuItem), 1);
        }
      }
    }
  }

  public static showEntireMenu(menu: NbMenuItem[]) {
    for (let i = 0; i < menu.length; i++) {
      let menuItem = menu[i];
      menuItem.hidden = false;

      if (menuItem.children != undefined) {
        MountMenu.showEntireMenu(menuItem.children);
      }
    }
  }

  public static hideMenuRadar(hideMenuRadar: boolean) {
    if (hideMenuRadar) this.hideMenuItem(this.menu, '/pages/report-vehicle-speed');
  }

  public static hideMenuItem(menu: NbMenuItem[], itemLink: string) {
    for (let i = 0; i < menu.length; i++) {
      let menuItem = menu[i];

      if (menuItem.link == itemLink) {
        menuItem.hidden = true;
        break;
      } else if (menuItem.children != undefined) {
        MountMenu.hideMenuItem(menuItem.children, itemLink);

        if (!menuItem.children.some((mc) => mc.hidden == false)) {
          menuItem.hidden = true;
        }
      }
    }
  }

  public static validadePageIfPageIsAllowed(
    pageLink: string,
    currentRole,
    roleRestriction: string[],
    restrictions: { forRole: string; condition: string }[],
    conditions: { key: string; value: string }[]
  ): boolean {
    if (roleRestriction.length > 0 && !roleRestriction.includes(currentRole)) {
      MountMenu.hideMenuItem(this.menu, pageLink);
      return false;
    }

    for (const restrict of restrictions) {
      if (restrict.forRole == "" || restrict.forRole == currentRole) {
        const condition = conditions == undefined ? undefined : conditions.find((c) => c.key == restrict.condition);
        if (condition == undefined || condition.value.toLocaleLowerCase() == "false") {
          MountMenu.hideMenuItem(this.menu, pageLink);
          return false;
        }
      }
    }
    return true;
  }

  public static goToRootPage(userRole: string, router: Router) {
    if (userRole === UserRoles.manager)
      router.navigate(["/pages/dashboard"]);
    else
      router.navigate(["/pages/authorizations"]);
  }

  public static initializeMenu(
    conditions: { key: string; value: string }[],
    router: Router
  ) {
    this.menu = [
      this._MENU_DASHBOARD,
      this._MENU_AUTHORIZATIONS,
      this._MENU_INVITES,
      this._MENU_RECENT_ACCS,
      this._MENU_RESIDENCE,
      this._MENU_COMPANY,
      this._MENU_DELIVERY_PACKAGE,
      this._MENU_REPORTS,
      this._MENU_DEVICES,
      this._MENU_SETTINGS,
    ];
    this.showEntireMenu(this.menu);

    // Get all links from menu and check if have restriction for each link
    let menuLinks = this.getMenuLinks(this.menu);
    let restrictionLinks = this.restrictions.map((r) => r.route);
    if (menuLinks.length > restrictionLinks.length) {
      let pending = menuLinks.filter((l) => !restrictionLinks.includes(l));
      console.error(`Fail to finds restrictions to: `, pending);
    }

    menuLinks.forEach((pageLink) => {
      const restriction = this.restrictions.find((r) => r.route == pageLink && r.route != undefined);
      let currentRole = AuthService.getUserRoleFromClaims();

      if (!this.validadePageIfPageIsAllowed(
        pageLink,
        currentRole,
        restriction.allowedRoles,
        restriction.conditionForRoles,
        conditions)
      ) 
      {
        if (router.url.includes(pageLink)) {
          this.goToRootPage(currentRole, router);
        }
      }
    });
  }

  private static getMenuLinks(menu: NbMenuItem[]): string[] {
    let links = [];
    menu.forEach((mi) => {
      if (mi.children != undefined) {
        links = links.concat(this.getMenuLinks(mi.children));
      } else if (mi.link != undefined) {
        links.push(mi.link);
      }
    });

    return links;
  }

  /**
   * Selects the item in the menu
   * @param toSelect link of the item that you want selected
   */
  public static select(toSelect: string): void {
    /* INSERIR AQUI UMA REFERÊNCIA PARA CADA ITEM DO MENU CRIADO (SEM EXCEÇÃO)*/
    let _menu_items: NbMenuItem[] = [
      this._MENU_DASHBOARD,
      this._MENU_ACCESS_POINT,
      this._MENU_CHARGE_RULE,
      this._MENU_RECENT_ACCS,
      this._MENU_RECENT_ACCS_PERSON,
      this._MENU_RECENT_ACCS_VEHICLE,
      this._MENU_DELIVERY_PACKAGE,
      this._MENU_REPORTS,
      this._MENU_COMPANY,
      this._MENU_RESIDENCE,
      this._MENU_USR_MANAGEMENT,
      //this._MENU_AUTH_VISITOR,
      //this._MENU_LOBBY,
      this._MENU_DEVICES,
      this._MENU_AUTHORIZATIONS,
      this._MENU_INVITES,
      //this._MENU_AUTH_EMPLOYEE,
      this._MENU_LICENSE,
      this._MENU_IMPORTS,
      this._MENU_SETTINGS,
      this._MENU_REPORT_VEHICLE_SPEEED,
    ];

    _menu_items.forEach((item) => {
      if (item.link == toSelect) item.selected = true;
      else if (item.children) {
        item.children.forEach(
          (children) =>
            (children.selected = children.link == toSelect ? true : false)
        );
      } else item.selected = false;
    });
  }
}
